import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Bug"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-bug',
    templateUrl: './icon-bug.component.html',
    styleUrls: ['./icon-bug.component.scss'],
    standalone: false
})
export class IconBugComponent  {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
